import { GuaranteesApplicationStatus } from '~/store/guarantees/types.ts';

export const UDBTF_GUARANTEE_SCAN_COPY_TEXT = {
  sectionStep: '09',
  sectionTitle: 'Долучення сканкопії гарантії',
  sectionDescription: '',
  emptyPreviewText: 'Сканкопію гарантії ще не завантажено.',
  addDocumentButton: 'Додати документ',
  openButton: 'Відкрити документ',
  deleteButton: 'Видалити',
  previewLoadingText: 'Завантажуємо документ...',
  previewTitle: 'Сканкопія гарантії',
  issueDetailsStep: '09.1',
  issueDetailsTitle: 'Дані операції гарантії',
  issueDetailsDescription: '',
  managementAccountingProductLabel: 'Продукт управлінського обліку',
  operationProvidedDateLabel: 'Дата надання гарантії',
  operationFinishedDateLabel: 'Дата завершення операції',
  saveButton: 'Зберегти',
  saveSuccessMessage: 'Дані операції гарантії збережено',
  confirmButton: 'Підтвердити',
  submitSuccessMessage: 'Заявку передано на УСАПОК',
  successCloseButton: 'Закрити',
  missingFileMessage: 'Файл не завантажено.',
  accessDeniedText: 'У вас немає доступу до кроку долучення сканкопії гарантії.',
  fallbackFileName: 'guarantee-scan-copy.pdf',
} as const;

export const UDBTF_GUARANTEE_SCAN_COPY_GET_STARTED_PATH =
  '/guarantees/administrator/get-started';
export const UDBTF_GUARANTEE_SCAN_COPY_TASKS_PATH = '/tasks';

export const udbtfGuaranteeScanCopyEditableStatuses = new Set<GuaranteesApplicationStatus>([
  GuaranteesApplicationStatus.AWAITING_UDBTF_APPROVAL,
  GuaranteesApplicationStatus.IN_PROGRESS_UDBTF_APPROVAL,
]);
